import { useMediaQuery, useTheme } from '@mui/material';

export const useEditor = () => {
    const theme = useTheme();
    const compactMode = useMediaQuery(theme.breakpoints.down('elg'));

    const SHEET_LINE = compactMode ? 17 : 20;
    const SHEET_HEIGHT = compactMode ? 850 : 1000;
    const A4_HEIGHT_FORMAT = 1150;
    const EDITOR_BLOCKS_WIDTH = compactMode ? '520px' : '690px';
    const DIALOGUE_BLOCKS_WIDTH = compactMode ? '310px' : '366px';

    return {
        A4_HEIGHT_FORMAT,
        EDITOR_BLOCKS_WIDTH,
        DIALOGUE_BLOCKS_WIDTH,
        compactMode,
        SHEET_HEIGHT,
        SHEET_LINE,
    };
};
